import { render, staticRenderFns } from "./AcceleratorMenu.vue?vue&type=template&id=157b4842"
import script from "./AcceleratorMenu.vue?vue&type=script&lang=js"
export * from "./AcceleratorMenu.vue?vue&type=script&lang=js"
import style0 from "./AcceleratorMenu.vue?vue&type=style&index=0&id=157b4842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports